module.exports = __webpack_public_path__ + "static/media/bicycle.ac519958.svg";